// extracted by mini-css-extract-plugin
export var aside = "Markdown-module--aside--e9b55";
export var max = "Markdown-module--max--b7164";
export var root = "Markdown-module--root--e75d1";